type SvgProps = { color: string };

const FacebookSvg = ({ color }: SvgProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none">
    <rect width={31} height={31} x={0.5} y={0.5} stroke={color} rx={15.5} />
    <path
      fill={color}
      d="M20.2 7.6h-2.291c-1.013 0-1.984.442-2.7 1.23-.716.787-1.118 1.856-1.118 2.97v2.52H11.8v3.36h2.29v6.72h3.055v-6.72h2.291l.764-3.36h-3.055V11.8c0-.223.08-.437.224-.594a.73.73 0 0 1 .54-.246h2.29V7.6Z"
    />
  </svg>
);

const PinterestSvg = ({ color }: SvgProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none">
    <path
      fill={color}
      d="M27 14c0 2.821-.988 5.4-2.779 7.264C22.55 23 20.281 24 18 24c-2.235 0-3.727-.733-4.679-1.5l-1.347 5.729a1 1 0 0 1-1.204.745 1 1 0 0 1-.75-1.203l4-17a1 1 0 0 1 1.947.458l-2.112 8.975C14.25 20.75 15.412 22 18 22c3.441 0 7-2.992 7-8a9 9 0 1 0-16.796 4.5 1 1 0 0 1-1.732 1A11 11 0 1 1 27 14Z"
    />
  </svg>
);

const LinkedinSvg = ({ color }: SvgProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none">
    <rect width={31} height={31} x={0.5} y={0.5} stroke={color} rx={15.5} />
    <path
      fill={color}
      d="M19.3 12.998a5.16 5.16 0 0 1 3.606 1.46 4.928 4.928 0 0 1 1.494 3.525v5.815H21v-5.815c0-.441-.18-.864-.498-1.175a1.72 1.72 0 0 0-1.202-.487c-.451 0-.884.175-1.202.487a1.643 1.643 0 0 0-.498 1.175v5.815h-3.4v-5.815c0-1.322.537-2.59 1.494-3.525a5.16 5.16 0 0 1 3.606-1.46ZM11.2 13.6H7.6v10.2h3.6V13.6ZM9.4 11.801a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6Z"
    />
  </svg>
);

const TwitterXSvg = ({ color }: SvgProps) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 1200 1227"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z"
      fill={color}
    />
  </svg>
);

const WhatsappSvg = ({ color }: SvgProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none">
    <path
      fill={color}
      d="m23.448 18.105-4-2a1 1 0 0 0-1 .063l-1.837 1.224a5.069 5.069 0 0 1-2-2l1.225-1.836a1 1 0 0 0 .063-1l-2-4A1 1 0 0 0 13 8a5 5 0 0 0-5 5 11.012 11.012 0 0 0 11 11 5 5 0 0 0 5-5 1 1 0 0 0-.552-.895ZM19 22a9.01 9.01 0 0 1-9-9 3 3 0 0 1 2.411-2.943l1.435 2.875-1.221 1.818a1 1 0 0 0-.091.939 7.059 7.059 0 0 0 3.768 3.768 1 1 0 0 0 .948-.082l1.826-1.218 2.875 1.436A3 3 0 0 1 19 22ZM16 3A13 13 0 0 0 4.523 22.11l-1.42 4.256a2 2 0 0 0 2.53 2.53l4.257-1.419A13 13 0 1 0 16 3Zm0 24a10.984 10.984 0 0 1-5.508-1.476 1 1 0 0 0-.817-.084L5 27l1.559-4.675a1 1 0 0 0-.083-.817A11 11 0 1 1 16 27Z"
    />
  </svg>
);

export { FacebookSvg, PinterestSvg, LinkedinSvg, TwitterXSvg, WhatsappSvg };
